var app = require('app');
app.init();

if (module.hot) {
    module.hot.accept();
}

